var React = require('react');

function LocationPin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.00001 0.833984C2.42001 0.833984 0.333344 2.92065 0.333344 5.50065C0.333344 9.00065 5.00001 14.1673 5.00001 14.1673C5.00001 14.1673 9.66668 9.00065 9.66668 5.50065C9.66668 2.92065 7.58001 0.833984 5.00001 0.833984ZM5.00001 7.16732C4.08001 7.16732 3.33334 6.42065 3.33334 5.50065C3.33334 4.58065 4.08001 3.83398 5.00001 3.83398C5.92001 3.83398 6.66668 4.58065 6.66668 5.50065C6.66668 6.42065 5.92001 7.16732 5.00001 7.16732Z","fill":"black","fillOpacity":"0.87"}));
}

LocationPin.defaultProps = {"width":"10","height":"15","viewBox":"0 0 10 15","fill":"none"};

module.exports = LocationPin;

LocationPin.default = LocationPin;
